<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>

        <div class="container-fluid">
          <div class="col-sm-12">
            <vs-breadcrumb
              align="left"
              :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Advisor/advisordashboard'
                    },
                    {
                      title: 'Training Detail Report',
                      url: '/#/dashboard/Advisor/trainingDetailView',
                      active: true
                    }
                  ]"
            ></vs-breadcrumb>
            <div class="heading mt-3">
              <h3 class="text-secondary">Training Detail Report</h3>
            </div>

            <div class="form-group form-row text-dark">
              <h6 class="sub-frm-title">Event Information</h6>
              <div class="row col-sm-12">
                <label class="col-sm-2 font-weight-bold">Title:</label>

                <div class="col-sm-10">{{trainingReport.title}}</div>
              </div>
              <div class="row col-sm-12">
                <label
                  class="col-sm-2 font-weight-bold"
                  style="padding:0px 0px 0px 15px"
                >Project Title:</label>
                <p
                  class="col-sm-2"
                  style="padding:0px 0px 0px 15px"
                  v-if="trainingReport.project"
                >{{trainingReport.project.title}}</p>

                <label class="col-sm-2 font-weight-bold p-0">Sub Program:</label>
                <p
                  class="col-sm-2 p-0"
                  v-if="trainingReport.subprogram"
                >{{trainingReport.subprogram.title}}</p>
                <label class="col-sm-2 font-weight-bold p-0">Assigned To:</label>
                <p
                  class="col-sm-2 p-0"
                  v-if="trainingReport.programofficer"
                >{{trainingReport.programofficer.name}}</p>
              </div>
              <div class="row col-sm-12">
                <label
                  class="col-sm-2 font-weight-bold"
                  style="padding:0px 0px 0px 15px"
                >Funding Agency(s):</label>
                <template v-if="fundingagency !=''">
                  <p
                    class="col-sm-3"
                    style="padding:0px 0px 0px 15px"
                    v-for="(agency,index) in fundingagency"
                    :key="index"
                  >{{agency.title}}</p>
                </template>
              </div>
              <div class="row col-sm-12">
                <label
                  class="col-sm-2 font-weight-bold"
                  style="padding:0px 0px 0px 15px"
                >Thematic Area:</label>
                <template v-if="thematicArea !=''">
                  <p
                    class="col-sm-3"
                    style="padding:0px 0px 0px 15px"
                    v-for="(thematics,tindex) in thematicArea"
                    :key="tindex"
                  >{{thematics.name}}</p>
                </template>
              </div>
              <div class="row col-sm-12">
                <label
                  class="col-sm-2 font-weight-bold"
                  style="padding:0px 0px 0px 15px"
                >No of Day(s)</label>
                <p class="col-sm-4" style="padding:0px 0px 0px 15px">{{trainingReport.noofdays}}</p>
              </div>
            </div>
            <div class="form-group form-row text-dark">
              <h6 class="sub-frm-title">Agenda</h6>
              <div class="row col-sm-12">
                <!-- Agenda 1 -->
                <div class="col-sm-5">
                  <vs-tabs v-if="agendasArray.length">
                    <!-- Tab Day 1 -->
                    <vs-tab v-for="(day,index) in newArr" :key="index" :label="'Day '+(day.day)">
                      <div :key="i" class="con-tab-ejemplo">
                        <div class="card latest-update-card">
                          <div class="card-block">
                            <div class="scroll-widget" v-for="(agenda,i) in day.data" :key="i">
                              <div class="latest-update-box">
                                <div class="row m-t-25 p-b-30">
                                  <div class="col-auto text-right update-meta p-r-0">
                                    <i
                                      v-if="i==0"
                                      class="material-icons text-success update-icon"
                                    >donut_large</i>
                                    <i
                                      v-else-if="i==1"
                                      class="material-icons text-warning update-icon"
                                    >donut_large</i>
                                    <i
                                      v-else-if="i==2"
                                      class="material-icons text-danger update-icon"
                                    >donut_large</i>
                                    <i
                                      v-else
                                      class="material-icons text-primary update-icon"
                                    >donut_large</i>
                                  </div>
                                  <div class="col p-l-5">
                                    <a>
                                      <h6>{{agenda.session}}:</h6>
                                    </a>
                                    <!-- <p class="text-muted m-b-0">
                                  <b>Monday</b> 12/6/2019
                                    </p>-->
                                    <p class="text-muted m-b-0">
                                      <b>Time</b>
                                      {{agenda.fromtime}} to {{agenda.totime}}
                                    </p>
                                    <p class="text-muted m-b-0">
                                      <b>Training By</b>
                                      <span class="text-capitalize">{{agenda.user.name}}</span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </vs-tab>
                  </vs-tabs>
                  <div v-else>No Agenda found for this training</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>

import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import "bootstrap/dist/css/bootstrap.css";
// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import axios from "axios";


export default {
  data: () => ({
    isSidebar: false,
    trainingReport: [],
    thematicArea: [],
    fundingagency: [],
    newArr: [],
    agendasArray: [],
    checkBox1: false,
    checkBox2: false,
    checkBox3: false,
    checkBox4: false,
    currentQ: 0
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.trainingCode = this.$route.query.trainingId;
    // Set the initial number of items
    this.openLoading();
    axios
      .get(
        process.env.VUE_APP_BASE_PATH +
          "/advisor/trainingsingle/detail-report/get/" +
          this.trainingCode
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.trainingId = response.data.trainingreport.id;
        if (response.data && response.data.trainingreport != undefined) {
          this.trainingReport = response.data.trainingreport;
        }
        if (response.data && response.data.thematic != null) {
          this.thematicArea = response.data.thematic;
        }
        if (response.data && response.data.fundingagency != null) {
          this.fundingagency = response.data.fundingagency;
        }
        this.loadAgendaData();
      });
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    loadAgendaData: function loadAgendaData() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/get/training/agenda/" +
            this.trainingId
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data != undefined && response.data.length > 0) {
            this.agendasArray = response.data;
            this.agendasArray.forEach(val => {
              if (this.newArr.some(person => person.day === val.days)) {
                this.dayIndex = this.newArr.map(e => e.day).indexOf(val.days);
                this.newArr[this.dayIndex].data.push(val);
              } else {
                this.newArr.push({
                  day: val.days,
                  data: [val]
                });
              }
            });
          }
        });
    }
  }
};
</script>
<style>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
li {
  list-style-type: none !important;
}

.f-500 {
  font-weight: 500;
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #fff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.save-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 0px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #f9f9f9;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}

.vs-popup--background {
  opacity: 0.3 !important;
}
.con-img-upload .img-upload {
  width: 150px !important;
}
.cont-bdr {
  display: none;
}
@media print {
  .print-btn {
    display: none;
  }
  .cont-bdr {
    display: block;
  }
  .heading {
    display: none;
  }
}
.cont-bdr {
  border-top: 1px solid #ebe9e9;
  border-right: 1px solid #ebe9e9;
}
.col-bdr-bottom {
  border-bottom: 0.5px solid #ebe9e9;
  border-left: 0.5px solid #ebe9e9;
}

/* agenda css starts */
.p-0 {
  padding: 0px;
}
.p-t-0 {
  padding-top: 0px;
}
.p-b-0 {
  padding-bottom: 0px;
}
.p-l-0 {
  padding-left: 0px;
}
.p-r-0 {
  padding-right: 0px;
}
.m-0 {
  margin: 0px;
}
.m-t-0 {
  margin-top: 0px;
}
.m-b-0 {
  margin-bottom: 0px;
}
.m-l-0 {
  margin-left: 0px;
}
.m-r-0 {
  margin-right: 0px;
}
.p-5 {
  padding: 5px;
}
.p-t-5 {
  padding-top: 5px;
}
.p-b-5 {
  padding-bottom: 5px;
}
.p-l-5 {
  padding-left: 5px;
}
.p-r-5 {
  padding-right: 5px;
}
.m-5 {
  margin: 5px;
}
.m-t-5 {
  margin-top: 5px;
}
.m-b-5 {
  margin-bottom: 5px;
}
.m-l-5 {
  margin-left: 5px;
}
.m-r-5 {
  margin-right: 5px;
}
.p-10 {
  padding: 10px;
}
.p-t-10 {
  padding-top: 10px;
}
.p-b-10 {
  padding-bottom: 10px;
}
.p-l-10 {
  padding-left: 10px;
}
.p-r-10 {
  padding-right: 10px;
}
.m-10 {
  margin: 10px;
}
.m-t-10 {
  margin-top: 10px;
}
.m-b-10 {
  margin-bottom: 10px;
}
.m-l-10 {
  margin-left: 10px;
}
.m-r-10 {
  margin-right: 10px;
}
.p-15 {
  padding: 15px;
}
.p-t-15 {
  padding-top: 15px;
}
.p-b-15 {
  padding-bottom: 15px;
}
.p-l-15 {
  padding-left: 15px;
}
.p-r-15 {
  padding-right: 15px;
}
.m-15 {
  margin: 15px;
}
.m-t-15 {
  margin-top: 15px;
}
.m-b-15 {
  margin-bottom: 15px;
}
.m-l-15 {
  margin-left: 15px;
}
.m-r-15 {
  margin-right: 15px;
}
.p-20 {
  padding: 20px;
}
.p-t-20 {
  padding-top: 20px;
}
.p-b-20 {
  padding-bottom: 20px;
}
.p-l-20 {
  padding-left: 20px;
}
.p-r-20 {
  padding-right: 20px;
}
.m-20 {
  margin: 20px;
}
.m-t-20 {
  margin-top: 20px;
}
.m-b-20 {
  margin-bottom: 20px;
}
.m-l-20 {
  margin-left: 20px;
}
.m-r-20 {
  margin-right: 20px;
}
.p-25 {
  padding: 25px;
}
.p-t-25 {
  padding-top: 25px;
}
.p-b-25 {
  padding-bottom: 25px;
}
.p-l-25 {
  padding-left: 25px;
}
.p-r-25 {
  padding-right: 25px;
}
.m-25 {
  margin: 25px;
}
.m-t-25 {
  margin-top: 25px;
}
.m-b-25 {
  margin-bottom: 25px;
}
.m-l-25 {
  margin-left: 25px;
}
.m-r-25 {
  margin-right: 25px;
}
.p-30 {
  padding: 30px;
}
.p-t-30 {
  padding-top: 30px;
}
.p-b-30 {
  padding-bottom: 30px;
}
.p-l-30 {
  padding-left: 30px;
}
.p-r-30 {
  padding-right: 30px;
}
.m-30 {
  margin: 30px;
}
.m-t-30 {
  margin-top: 30px;
}
.m-b-30 {
  margin-bottom: 30px;
}
.m-l-30 {
  margin-left: 30px;
}
.m-r-30 {
  margin-right: 30px;
}
.p-35 {
  padding: 35px;
}
.p-t-35 {
  padding-top: 35px;
}
.p-b-35 {
  padding-bottom: 35px;
}
.p-l-35 {
  padding-left: 35px;
}
.p-r-35 {
  padding-right: 35px;
}
.m-35 {
  margin: 35px;
}
.m-t-35 {
  margin-top: 35px;
}
.m-b-35 {
  margin-bottom: 35px;
}
.m-l-35 {
  margin-left: 35px;
}
.m-r-35 {
  margin-right: 35px;
}
.p-40 {
  padding: 40px;
}
.p-t-40 {
  padding-top: 40px;
}
.p-b-40 {
  padding-bottom: 40px;
}
.p-l-40 {
  padding-left: 40px;
}
.p-r-40 {
  padding-right: 40px;
}
.m-40 {
  margin: 40px;
}
.m-t-40 {
  margin-top: 40px;
}
.m-b-40 {
  margin-bottom: 40px;
}
.m-l-40 {
  margin-left: 40px;
}
.m-r-40 {
  margin-right: 40px;
}
.p-45 {
  padding: 45px;
}
.p-t-45 {
  padding-top: 45px;
}
.p-b-45 {
  padding-bottom: 45px;
}
.p-l-45 {
  padding-left: 45px;
}
.p-r-45 {
  padding-right: 45px;
}
.m-45 {
  margin: 45px;
}
.m-t-45 {
  margin-top: 45px;
}
.m-b-45 {
  margin-bottom: 45px;
}
.m-l-45 {
  margin-left: 45px;
}
.m-r-45 {
  margin-right: 45px;
}
.p-50 {
  padding: 50px;
}
.p-t-50 {
  padding-top: 50px;
}
.p-b-50 {
  padding-bottom: 50px;
}
.p-l-50 {
  padding-left: 50px;
}
.p-r-50 {
  padding-right: 50px;
}
.m-50 {
  margin: 50px;
}
.m-t-50 {
  margin-top: 50px;
}
.m-b-50 {
  margin-bottom: 50px;
}
.m-l-50 {
  margin-left: 50px;
}
.m-r-50 {
  margin-right: 50px;
}
.v-b {
  vertical-align: bottom;
}

.card .card-header {
  background-color: transparent;
  border-bottom: none;
  padding: 20px;
  position: relative;
}
.latest-update-card .card-block {
  padding-top: 0;
}
.latest-update-card .card-block .latest-update-box {
  position: relative;
}
.latest-update-card .card-block .latest-update-box:after {
  content: "";
  position: absolute;
  background: #ebebeb;
  height: 100%;
  width: 3px;
  top: 0;
  left: 19px;
  z-index: 1;
}
.latest-update-card .card-block .latest-update-box .update-meta {
  z-index: 2;
}
.latest-update-card .card-block .latest-update-box .update-meta .update-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  padding: 7px 8px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  background: #fff;
}
.latest-update-card .card-block .update-icon.bg-c-red {
  -webkit-box-shadow: 0 0 0 4px rgba(255, 83, 112, 0.5);
  box-shadow: 0 0 0 4px rgba(255, 83, 112, 0.5);
}
.latest-update-card .card-block .update-icon.bg-c-blue {
  -webkit-box-shadow: 0 0 0 4px rgba(64, 153, 255, 0.5);
  box-shadow: 0 0 0 4px rgba(64, 153, 255, 0.5);
}
.latest-update-card .card-block .update-icon.bg-c-green {
  -webkit-box-shadow: 0 0 0 4px rgba(46, 216, 182, 0.5);
  box-shadow: 0 0 0 4px rgba(46, 216, 182, 0.5);
}
.latest-update-card .card-block .update-icon.bg-c-yellow {
  -webkit-box-shadow: 0 0 0 4px rgba(255, 182, 77, 0.5);
  box-shadow: 0 0 0 4px rgba(255, 182, 77, 0.5);
}
.latest-update-card .card-block .update-icon.ring {
  border-width: 3px;
  width: 15px;
  height: 15px;
  padding: 0;
  display: block;
  margin-left: 13px;
  background: #fff;
}
.latest-update-card .card-block .latest-update-box .update-meta i.update-icon {
  margin-left: 4px;
  margin-right: 19px;
}
.latest-update-card .card-block .update-icon {
  padding: 0;
  width: 40px;
  height: 40px;
}
/* agenda css ends */
</style>


